module.exports = __webpack_public_path__ + "static/media/whatfixchart.36d47ae9.svg";